import { render } from "./HomepageSectionForm.vue?vue&type=template&id=467d5966"
import script from "./HomepageSectionForm.vue?vue&type=script&lang=js"
export * from "./HomepageSectionForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__